<template>
  <div class="c-fa-new-step3 header">
    Perkenalkan diri Anda
    <div class="c-fa-new-step3-content mb-5">
      Agen kami ingin mengetahui dengan siapa dia akan bertemu. Mohon tulis nama asli Anda.
      <div class="input-group mt-4">
        <div class="input-group-prepend" data-toggle="modal" data-target="#exampleModal" style="cursor:pointer">
          <div class="input-group-text"> 
            <span style="width: 50px;">
              {{ textSalutation }}
            </span>
            <img alt="delete" src="../../../../../assets/images/svg/ic-caret-down.svg">
          </div>
        </div>
        <input type="text" class="form-control p-3 form-control-step-3" id="inlineFormInputGroup" placeholder="Nama lengkap" :value="leadName" @input="setLeadName">
      </div>
      <div v-if="error" class="form-group col-sm-12 text-error">
        <img src="../../../../../assets/images/svg/ic-warning.svg" style="padding-right: 10px;">
        {{ errorText }}
      </div>
    </div>
    <!-- Button trigger modal -->

    <!-- Modal -->
    <div class="modal fade " id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-bottom" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <a data-dismiss="modal" aria-label="Close" style="padding-left: 90%;">
              <img alt="delete" src="../../../../../assets/images/svg/times.svg" style="margin-left: 10px;" @click="closeModal()">
            </a>
          </div>
          <div class="modal-body" style="text-align: left; height: 25vh;">
            <ul class="list-group">
              <li
                v-for="(salutation, key) in masterSalutations"
                :key="key"
                class="list-group-item"
                :class="{
                  'active': chooseSalutation == salutation.value
                }"
                @click="setSalutation(salutation.value, salutation.text)"
              >
                <div class="row">
                  <div class="col-sm-11 resize-11">
                    {{ salutation.text }}
                  </div>
                  <div class="col-sm-1 resize-1">
                    <img v-if="chooseSalutation == salutation.value"  src="../../../../../assets/images/svg/selected.svg"  class="image-padding">
                  </div>
                </div>
              </li>
            </ul>
            <button  class="buttom-modal button-continue" :disabled="chooseSalutation == null" @click="closeModal()">
              PILIH
            </button>
          </div>
        </div>
      </div>
    </div>
    <button  class="button-fixed-1 button-continue" 
      :disabled="error || leadName == '' " 
      @click="nextStep()"
    >
      LANJUTKAN
    </button>
  </div>
</template>

<script>
export default {
  name: 'Step3',
  data() {
    return {
      chooseSalutation: 'bapak',
      textSalutation: 'Bapak',
      error: false,
      leadName: '',
      masterSalutations: [
        {
          value: 'bapak',
          text: 'Bapak'
        },
        {
          value: 'ibu',
          text: 'Ibu'
        }
      ]
    }
  },
  props: {
    name: {
      type: String,
      default: null,
    },
    salutation: {
      type: String,
      default: null,
    }
  },
  created() {
    this.chooseSalutation = this.salutation;
    this.leadName = this.name;
    this.textSalutation = this.masterSalutations.find(salution => salution.value === this.salutation).text;
  },
  methods: {
    setSalutation(value, text) {
      this.chooseSalutation = value;
      this.textSalutation = text;
    },
    closeModal() {
      $('#exampleModal').modal('toggle');
    },
    setLeadName(event) {
      this.leadName = event.target.value;
      if (this.chooseSalutation == null || this.leadName == '' || !this.leadName.replace(/\s/g, '').length) {
        this.error = true;
        this.errorText = 'Field harus diisi'
      } else if (this.leadName.length < 3 || this.leadName.length > 100) {
        this.error = true;
        this.errorText = 'Nama lengkap harus minimal 3 karakter dan tidak boleh melebihi 100 karakter';
      } else if (this.leadName != '' && !this.onlyLettersAndSpaces(this.leadName) ) {
        this.error = true;
        this.errorText = 'Nama hanya boleh karakter alfabet dan spasi'
      } else {
        this.error = false;
        this.errorText = ''

      }
    },
    onlyLettersAndSpaces(str) {
      return /^[A-Za-z\s]*$/.test(str)
    },
    nextStep() {
      this.$emit('submit:leadName', this.leadName);
      this.$emit('submit:salutation', this.chooseSalutation);
    }
  }
};
</script>
